/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-send-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.319 2.681a.625.625 0 00-.656-.143l-13.75 5a.625.625 0 000 1.168l6 2.4 2.4 6a.625.625 0 00.562.394.625.625 0 00.575-.413l5-13.75a.625.625 0 00-.131-.656zm-5.444 12.444l-1.744-4.375 2.994-2.994-.881-.881-3.019 3.019-4.35-1.769 10.956-3.956-3.956 10.956z"/>'
  }
})
